<div class="answers-log-card">
  <h3 class="font-18 font-bold title">سجل الإجابات</h3>

  @if (answers.length > 0) {
    <div class="table-responsive">
      <table class="answers-table">
        <thead>
          <tr>
            <th class="col-expert">الخبير</th>
            <th class="col-answer">اجابة الخبير</th>
            <th class="col-date">تاريخ الايجابة</th>
            <th class="col-actions"></th>
          </tr>
        </thead>
        <tbody>
          @for (answer of answers; track answer.id; let isEven = $even) {
            <tr [class.even-row]="isEven" [class.odd-row]="!isEven">
              <td class="col-expert">
                <div class="expert-cell">
                  <img [src]="answer.expertAvatar || 'assets/images/avatar.svg'" alt="" class="expert-avatar" />
                  @if (answer.expertId) {
                    <a [href]="'/pages/inspectors/inspector-profile/' + answer.expertId" target="_blank" class="expert-name">{{ answer.expertName }}</a>
                  } @else {
                    <span class="expert-name">{{ answer.expertName }}</span>
                  }
                </div>
              </td>
              <td class="col-answer">{{ answer.answerText }}</td>
              <td class="col-date"><bdi class="text-nowrap">{{ answer.date | saudiDateTime }}</bdi></td>
              <td class="col-actions">
                <button class="btn-delete-row" (click)="deleteAnswer(answer)">
                  <img src="assets/images/svg/DELETE1.svg" alt="حذف" class="delete-icon" />
                  <span class="delete-text">حذف</span>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <p class="no-data">لا توجد إجابات</p>
  }
</div>
